import GuestPortal from '../src/containers/GuestPortal';

export default GuestPortal;
